import "../../styles/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useEffect, useState } from "react";
import HeaderBar from "./HeaderBar";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useData } from "./MemberData";
import { Modal, Backdrop, Fade, Box } from "@mui/material";
import { useTheme } from "./ThemeContext";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import axios from "axios";

type WeekObject = {
  week: number;
  year: number;
};

interface ActivityData {
  callsign: number;
  days: string;
  weekly_report: string;
}

interface OpenDuties {
  callsign: number;
  start_clock: Date;
  status: string;
}

interface Activity {
  monday: string | number | null;
  tuesday: string | number | null;
  wednesday: string | number | null;
  thursday: string | number | null;
  friday: string | number | null;
  saturday: string | number | null;
  sunday: string | number | null;
}

function ActivityPage() {
  const { membersData, loading, getMemberInfo, getDiscordMemberInfo } = useData();
  const [searchTerm, setSearchTerm] = useState("");
  const [activityData, setActivityData] = useState<ActivityData[]>([]);
  const [allDutyOpen, setAllDutyOpen] = useState(false);
  const [openDuties, setOpenDuties] = useState<OpenDuties[]>([]);
  const [activityRaportOpen, setActivityOpen] = useState(false);
  const [gestRaport, setGestRaportOpen] = useState(false);
  const { theme } = useTheme();
  const [selectedMember, setSelected] = useState("");
  const [activityWeeks, setActivityWeeks] = useState<string[]>([
    "",
    "",
    "",
    "",
  ]);
  const [cancelCallsign, setCancelCallsign] = useState("");
  const [cancelStartTime, setCancelStartTime] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [cancelDutyOpen, setCancelDutyOpen] = useState(false);
  const [manageDutyData, setDutyData] = useState<Activity[]>([]);
  const [selectedCallsign, setSelectedCallsign] = useState(0);

  const [myDiscordID, setMyDiscordID] = useState("");

  useEffect(() => {
    const idFromCookies = Cookies.get("myDiscordID") || "";
    setMyDiscordID(idFromCookies);
  }, []);

  useEffect(() => {
    if (myDiscordID) {
      getActivityData();
    }
  }, [myDiscordID]);

  if (loading) {
    return (
      <div className="w-full h-full flex flex-col">
        <HeaderBar currentPage="Evidenta Activitate" />
        <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
          <div className="w-full h-full flex items-center justify-between">
            <span className="w-full textExtraBold text-[#323232] text-[2vw] flex items-center justify-center">
              Pagina se incarca!
            </span>
          </div>
        </div>
      </div>
    );
  }

  const filteredMembers = membersData
    .filter((member) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        member.full_name.toLowerCase().includes(searchLower) ||
        String(member.callsign).padStart(3, "0").includes(searchLower) ||
        String(member.user_id).includes(searchLower)
      );
    })
    .sort((a, b) => a.callsign - b.callsign);

  async function getActivityData() {
    try {
      const response = await axios.get("http://panelmedici.fplayt.ro:5000/activity/get");
      if (response && response.data) {
        setActivityData(response.data);
      } else {
        setActivityData([]);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      setActivityData([]);
    }
  }

  function calculateAverage(arr: (number | string | undefined)[]): number {
    const filteredNumbers = arr
      .map((value) => Number(value))
      .filter((value) => !isNaN(value));

    if (filteredNumbers.length === 0) return 0;

    const sum = filteredNumbers.reduce((acc, curr) => acc + curr, 0);

    const average = sum / filteredNumbers.length;

    return Math.ceil(average);
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "60%",
    display: "flex",
    flexDirection: "column",
    gap: "2%",
    bgcolor: theme === "dark" ? "#191919" : "white",
    boxShadow: 24,
    borderRadius: ".3vw",
    outline: "none",
    p: 4,
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    gap: "2%",
    bgcolor: theme === "dark" ? "#191919" : "white",
    boxShadow: 24,
    borderRadius: ".3vw",
    outline: "none",
    p: 4,
  };

  const cancelDutyStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const openDutyModal = async () => {
    try {
      const response = await axios.get(
        "http://panelmedici.fplayt.ro:5000/activity/getActiveDuties"
      );
      if (response && response.data) {
        setOpenDuties(response.data);
      }
      setAllDutyOpen(true);
    } catch (err) {
      console.log(err);
      toast.error(
        "A aparut o eroare! Lista cu pontajele active nu a putut fi incarcata."
      );
    }
  };

  const handleAllDutyClose = () => {
    setAllDutyOpen(false);
  };

  const handleTokenRefresh = async () => {
      try {
          let refreshToken = Cookies.get("refreshToken");
          const response = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
              refreshToken: refreshToken
          });

          if (response.statusText === "OK") {
              const newAccessToken = response.data.accessToken;
              Cookies.set("accessToken", newAccessToken, { expires: 7 });
          } else {
              toast.error("Nu am putut reînnoi tokenul! Te rog să te loghezi din nou.");
          }
      } catch (err) {
          console.log("Token refresh failed:", err);
          toast.error("Eroare la reînnoirea tokenului. Te rog să te loghezi din nou.");
      }
  };

  const handleDutyCancelClose = () => {
    setCancelDutyOpen(false);
    setCancelCallsign("");
    setCancelReason(""); 
    setCancelStartTime("");
  }

  const handleDutyCancelOpen = (callsign: any, startTime: any) => {
    setCancelCallsign(callsign);
    setCancelStartTime(startTime);
    setCancelDutyOpen(true);
  }

  const cancelDuty = async () => {
    const callsign = cancelCallsign;
    const startTime = cancelStartTime;
    const reasonInput = cancelReason;
    try {
      let token = Cookies.get("accessToken");
      await axios.post(
        "http://panelmedici.fplayt.ro:5000/activity/cancelDuty",
        {
          callsign: Number(callsign),
          startTime: startTime,
          discordID: getMemberInfo(Number(callsign), "discordID"),
          myDiscord: myDiscordID,
          full_name: getMemberInfo(Number(callsign), "full_name"),
          reasonInput: reasonInput
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      openDutyModal();
      toast.success("Pontaj anulat cu succes!");
    } catch (err) {
      console.log(err);
      if ((err as any).response && (err as any).response.status === 401) {
        await handleTokenRefresh();
        await cancelDuty();
      } else {
        toast.error("A aparut o eroare! Pontajul nu a fost anulat");
      }
    }
  }

  async function activityModalOpen(callsign: number) {
    setSelected(
      `[M-${String(callsign).padStart(3, "0")}] ${getMemberInfo(
        callsign,
        "full_name"
      )}`
    );
    for (let index = 0; index < activityData.length; index++) {
      const element = activityData[index];
      if (element.callsign === callsign) {
        setActivityWeeks(JSON.parse(element.weekly_report));
      }
    }
    setActivityOpen(true);
  }

  async function openModalAndCheckActivity(callsign: number) {
    await activityModalOpen(callsign);
  }

  const handleActivtyRaportClose = () => {
    setActivityOpen(false);
  };

  const getStartOfWeek = (week: any, year: any) => {
    const jan1 = new Date(year, 0, 1);
    const days = (week - 1) * 7 - jan1.getDay() + 1;
    return new Date(jan1.setDate(jan1.getDate() + days));
  };

  const formatWeekRange = (week: any, year: any) => {
    const startOfWeek = getStartOfWeek(week, year);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    const formatDate = (date: any) =>
      `${String(date.getDate()).padStart(2, "0")}.${String(
        date.getMonth() + 1
      ).padStart(2, "0")}.${date.getFullYear()}`;

    return `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
  };

  const getLastFourWeeks = () => {
    const today: Date = new Date();

    let currentWeek = Math.ceil(
      (today.getTime() - new Date(today.getFullYear(), 0, 1).getTime()) /
        (7 * 24 * 60 * 60 * 1000)
    );
    let currentYear = today.getFullYear();

    const weeks = [];
    for (let i = 0; i < 4; i++) {
      if (currentWeek === 0) {
        currentYear--;
        const lastDateOfPrevYear = new Date(currentYear, 11, 31);
        currentWeek = Math.ceil(
          (lastDateOfPrevYear.getTime() -
            new Date(currentYear, 0, 1).getTime()) /
            (7 * 24 * 60 * 60 * 1000)
        );
      }
      weeks.unshift({ week: currentWeek, year: currentYear });
      currentWeek--;
    }
    return weeks;
  };

  const weeks: WeekObject[] = getLastFourWeeks();

  const openChangeModal = async (callsign: number) => {
    setSelected(
      `[M-${String(callsign).padStart(3, "0")}] ${getMemberInfo(
        callsign,
        "full_name"
      )}`
    );

    try {
      const response = await axios.get(
        `http://panelmedici.fplayt.ro:5000/api/activityByCS?callsign=${callsign}`
      );
      if (response && response.data) {
        const day = JSON.parse(response.data[0].days);
        const dutyData = [
          {
            monday: day[0] || null,
            tuesday: day[1] || null,
            wednesday: day[2] || null,
            thursday: day[3] || null,
            friday: day[4] || null,
            saturday: day[5] || null,
            sunday: day[6] || null,
          },
        ];
        setSelectedCallsign(callsign);
        setDutyData(dutyData);
        setGestRaportOpen(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("A apărut o eroare! Nu s-a putut deschide meniul.");
      return;
    }
  };

  const handleGestRaportClose = () => {
    setGestRaportOpen(false);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    day: keyof Activity
  ) => {
    const value = e.target.value;

    setDutyData((prevData) => {
      const updatedData = [...prevData];
      if (updatedData[0]) {
        updatedData[0][day] = value;
      }
      return updatedData;
    });
  };

  const saveDutyData = async () => {
    try {
        let token = Cookies.get("accessToken");
        const response = await axios.post(
          "http://panelmedici.fplayt.ro:5000/activity/updateActivity",
          {
            callsign: selectedCallsign,
            days: [
              manageDutyData[0].monday,
              manageDutyData[0].tuesday,
              manageDutyData[0].wednesday,
              manageDutyData[0].thursday,
              manageDutyData[0].friday,
              manageDutyData[0].saturday,
              manageDutyData[0].sunday,
            ],
          }, 
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.statusText === "OK") {
            handleGestRaportClose();
            getActivityData();
            toast.success("Modificarile au fost salvate!");
        } else {
            toast.error("A aparut o eroare! Modificarile nu au fost salvate.");
            return;
        }
    } catch (err) {
      if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
        await handleTokenRefresh();
        await saveDutyData();
      } else {
        toast.error("A aparut o eroare! Modificarile nu au fost salvate.");
        console.log(err);
      }
    }
  };

  const isConducere = () => {
    for (let index = 0; index < membersData.length; index++) {
      const member = membersData[index];
      if (
        member.discordID === myDiscordID &&
        (member.grade === "Director-General" ||
          member.grade === "Director-Adjunct" ||
          member.grade === "Medic-Inspector" ||
          member.grade === "Medic-Chirurg")
      ) {
        return true;
      }
    }
    return false;
  };
  
  let lastFourWeeks = activityWeeks;
  const adjustWeeks = (weeks: any[]) => {
    const nonEmptyWeeks = weeks.filter((week: string) => week !== "");
    const result = new Array(4).fill("No Data");
    nonEmptyWeeks.reverse().forEach((week, index) => {
      result[3 - index] = week; 
    });
    return result;
  };
  lastFourWeeks = adjustWeeks(lastFourWeeks);
  
  return (
    <div className="w-full h-full flex flex-col">
      <HeaderBar currentPage="Evidenta Activitate" />
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">
            Activitate Departament
          </span>
          {(isConducere() || getDiscordMemberInfo(myDiscordID, "callsign") < 300) && (
            <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
              <div
                onClick={openDutyModal}
                className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
              >
                <span className="textBold text-white text-[.8vw]">
                  VEZI TOATE PONTAJELE ACTIVE
                </span>
              </div>
            </div>
          )}
          <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
            <input
              type="text"
              placeholder="Caută un medic"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
            />
            <FontAwesomeIcon
              className="text-[#00000050] dark:text-[#ffffff50] text-[0.8vw]"
              icon={faMagnifyingGlass}
            />
          </div>
        </div>
        <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
          {filteredMembers.map((memberData, index) => {
            const activity = activityData.find(
              (m) => m.callsign === memberData.callsign
            );
            let actData = Array(7).fill(0);
            if (activity) {
              actData = JSON.parse(activity.days);
            }
            const avg = calculateAverage(actData.map((day) => Number(day)));
            const callsign = getDiscordMemberInfo(memberData.discordID, "callsign");

            let greenThreshold = 0;
            let yellowThreshold = 0;

            if (callsign > 400) {
              greenThreshold = 120;
              yellowThreshold = 60;
            } else if (callsign > 300) {
              greenThreshold = 100;
              yellowThreshold = 50;
            } else if (callsign > 200) {
              greenThreshold = 80;
              yellowThreshold = 40;
            } else {
              greenThreshold = 60;
              yellowThreshold = 30;
            }
            return (
              <div
                key={index}
                className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
              >
                <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                  {memberData.user_id}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                  M-{String(memberData.callsign).padStart(3, "0")}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[11%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                  {memberData.full_name}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                  {memberData.grade}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Lu: {actData[0]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Ma: {actData[1]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Mi: {actData[2]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Jo: {actData[3]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Vi: {actData[4]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Sâ: {actData[5]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Du: {actData[6]}
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textSemiBold w-[4%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                  Medie:{" "}
                  <span
                    className={
                      avg >= greenThreshold
                      ? "text-green-500"
                      : avg >= yellowThreshold
                      ? "text-orange-500"
                      : "text-red-500"
                    }
                  >
                    {avg}
                  </span>
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <div
                  onClick={() => openModalAndCheckActivity(memberData.callsign)}
                  className="w-[10%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                >
                  <span className="textBold text-white text-[.8vw]">
                    RAPORT ACTIVITATE
                  </span>
                </div>
                {(isConducere() || (getDiscordMemberInfo(myDiscordID, "functions")?.['instructor panel'] === true || typeof getDiscordMemberInfo(myDiscordID, "functions")?.['instructor panel'] === "string")) && (
                  <>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                      <div
                        onClick={() => openChangeModal(memberData.callsign)}
                        className="w-[7%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                      >
                      <span className="textBold text-white text-[.8vw]">
                        GESTIONEAZA
                      </span>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={allDutyOpen}
        onClose={handleAllDutyClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={allDutyOpen}>
          <Box sx={style} className="flex flex-col">
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">
              LISTA PONTAJE ACTIVE
            </span>
            <div className="w-[100%] h-full bg-[#d6d6d6] dark:bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%] overflow-y-scroll">
              {openDuties.map((duty, index) => (
                <div
                  key={index}
                  className="w-full min-h-[14%] overflow-y-scroll border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]"
                >
                  <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                    M-{String(duty.callsign).padStart(3, "0")}
                  </span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                  <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                    {getMemberInfo(duty.callsign, "full_name")}
                  </span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                  <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                    Deschis la: {String(duty.start_clock)}
                  </span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                  <div
                    onClick={() =>
                      handleDutyCancelOpen(String(duty.callsign), duty.start_clock)
                    }
                    className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]"
                  >
                    <span className="textBold text-white text-[.8vw]">
                      ANULEAZA PONTAJ
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={cancelDutyOpen}
        onClose={handleDutyCancelClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={cancelDutyOpen}>
        <Box sx={cancelDutyStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">Anuleaza Pontaj M-{cancelCallsign.padStart(3, '0')}</span>
          <input
            onChange={e => setCancelReason(e.target.value)}
            placeholder="Introdu Motiv"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={cancelDuty} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">ANULEAZA PONTAJ</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={activityRaportOpen}
        onClose={handleActivtyRaportClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={activityRaportOpen}>
          <Box sx={style2} className="flex flex-col">
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">
              Raport activitate - {selectedMember}
            </span>
            <div className="w-[100%] h-full bg-[#d6d6d6] dark:bg-[#282828] box-border pt-[8%] rounded-[0.5vw] flex flex-row justify-center items-center">
            {weeks.map((weekObj: WeekObject, index: number) => {
              return (
                <div
                  key={index}
                  className="w-[20%] h-full flex flex-col gap-[2%]"
                >
                  <span className="textSemiBold text-[1.2vw] w-full text-center text-[#323232] dark:text-[#ffffff]">
                    CW{weekObj.week}:
                  </span>
                  <span className="textMedium text-[1.1vw] w-full text-center text-[#323232] dark:text-[#ffffff]">
                    {lastFourWeeks[index] || "No Data"}
                  </span>
                  <span className="textSmall text-[0.9vw] w-full text-center text-[#7d7d7d] dark:text-[#aaaaaa]">
                    {formatWeekRange(weekObj.week, weekObj.year)}
                  </span>
                </div>
              );
            })}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={gestRaport}
        onClose={handleGestRaportClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={gestRaport}>
          <Box sx={style2} className="flex flex-col">
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">
              Gestioneaza activitate - {selectedMember}
            </span>
            <div className="w-full h-full bg-[#d6d6d6] dark:bg-[#282828] box-border rounded-[0.5vw] flex items-center justify-between">
              <div className="w-[49%] h-full flex flex-col justify-center gap-[2%] box-border pl-[2%]">
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Luni:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.monday || ""}
                    onChange={(e) => handleInputChange(e, "monday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Marti:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.tuesday || ""}
                    onChange={(e) => handleInputChange(e, "tuesday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Miercuri:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.wednesday || ""}
                    onChange={(e) => handleInputChange(e, "wednesday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Joi:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.thursday || ""}
                    onChange={(e) => handleInputChange(e, "thursday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Vineri:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.friday || ""}
                    onChange={(e) => handleInputChange(e, "friday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Sambata:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.saturday || ""}
                    onChange={(e) => handleInputChange(e, "saturday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold text-black dark:text-white text-[.9vw]">
                    Duminica:{" "}
                  </span>
                  <input
                    value={manageDutyData[0]?.sunday || ""}
                    onChange={(e) => handleInputChange(e, "sunday")}
                    type="text"
                    placeholder="Introdu valoare"
                    className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F] text-black dark:text-white textMedium text-[.9vw] bg-transparent w-[40%]"
                  />
                </div>
              </div>
              <div className="w-[1px] h-[90%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <div className="w-[49%] h-full flex items-center justify-center">
                <div
                  onClick={saveDutyData}
                  className="py-[3%] px-[5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                >
                  <span className="textBold text-white text-[1.1vw]">
                    SALVEAZA ACTIVITATE
                  </span>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
      <ToastContainer />
    </div>
  );
}

export default ActivityPage;
